// This loads jQuery (automatically found in /node_modules/jquery)
global.$ = global.jQuery = require('jquery');

// Loads required libs
// import 'slick-carousel';
import 'magnific-popup';

// Escape code
var KEYCODE_ESC = 27;

// Run jquery
$(document).ready(function ()
{

/*
	##     ##    ###    #### ##    ##    ##     ## ######## ##    ## ##     ##
	###   ###   ## ##    ##  ###   ##    ###   ### ##       ###   ## ##     ##
	#### ####  ##   ##   ##  ####  ##    #### #### ##       ####  ## ##     ##
	## ### ## ##     ##  ##  ## ## ##    ## ### ## ######   ## ## ## ##     ##
	##     ## #########  ##  ##  ####    ##     ## ##       ##  #### ##     ##
	##     ## ##     ##  ##  ##   ###    ##     ## ##       ##   ### ##     ##
	##     ## ##     ## #### ##    ##    ##     ## ######## ##    ##  #######
*/
	// Toggle Main Menu when button clicked/tapped
	$('.hamburger').on('click touch', function ()
	{
		// Update icon
//		var icon = $(this).find('.icon use');
//		if ( icon.attr('xlink:href') == '#icon-menu' )
//		{
//			icon.attr('xlink:href', '#icon-close');
//		}
//		else
//		{
//			icon.attr('xlink:href', '#icon-menu');
//		}

		// Show/hide nav
		$('body').toggleClass('nav-active');
	})

	// Close menu if ESC is pressed
	$(document).keyup(function (e)
	{
		if (e.keyCode == KEYCODE_ESC) {
			$('body').removeClass('nav-active');
		}
	})


	// $( '.mbnav li:has(ul)' ).addClass( 'has-sub' );
	// $( '.mbnav .has-sub>a' ).after( '<em class="mbnav-caret">' );


    /* menu open and close on single click */
    $('.jsSubMenuToggle').on('click touch', function () {
		var element = $( this ).parent( 'li' );
		if ( element.hasClass( 'is-open' ) ) {
			element.removeClass( 'is-open' );
			element.find( 'li' ).removeClass( 'is-open' );
			element.find( 'ul' ).slideUp(200);
		}
		else {
			element.addClass( 'is-open' );
			element.children( 'ul' ).slideDown( 200 );
			element.siblings( 'li' ).children( 'ul' ).slideUp( 200 );
			element.siblings( 'li' ).removeClass( 'is-open' );
			element.siblings( 'li' ).find( 'li' ).removeClass( 'is-open' );
			element.siblings( 'li' ).find( 'ul' ).slideUp( 200 );
		}
	} );

/*
##     ## #### ########  ########  #######     ########   #######  ########  ##     ## ########
##     ##  ##  ##     ## ##       ##     ##    ##     ## ##     ## ##     ## ##     ## ##     ##
##     ##  ##  ##     ## ##       ##     ##    ##     ## ##     ## ##     ## ##     ## ##     ##
##     ##  ##  ##     ## ######   ##     ##    ########  ##     ## ########  ##     ## ########
 ##   ##   ##  ##     ## ##       ##     ##    ##        ##     ## ##        ##     ## ##
  ## ##    ##  ##     ## ##       ##     ##    ##        ##     ## ##        ##     ## ##
   ###    #### ########  ########  #######     ##         #######  ##         #######  ##
*/

	if ( $('.jsPopupIframe').length )
	{
		$('.jsPopupIframe').magnificPopup(
		{
			type: 'iframe',
			// showCloseBtn: false,
			fixedContentPos: true,
			// iframe:
			// {
			// 	markup: '<div class="mfp-iframe-scaler">'+
			// 			  '<div class="mfp-close"></div>'+
			// 			  '<iframe class="mfp-iframe" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>'+
			// 			'</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
			// },
			callbacks:
			{
				open: function()
				{
					$(".header__video").get(0).pause();
				},
				close: function()
				{
					$(".header__video").get(0).play();
				}
			}
		});
	}

/*
########     ###     ######   ######  ##      ##  #######  ########  ########   ######
##     ##   ## ##   ##    ## ##    ## ##  ##  ## ##     ## ##     ## ##     ## ##    ##
##     ##  ##   ##  ##       ##       ##  ##  ## ##     ## ##     ## ##     ## ##
########  ##     ##  ######   ######  ##  ##  ## ##     ## ########  ##     ##  ######
##        #########       ##       ## ##  ##  ## ##     ## ##   ##   ##     ##       ##
##        ##     ## ##    ## ##    ## ##  ##  ## ##     ## ##    ##  ##     ## ##    ##
##        ##     ##  ######   ######   ###  ###   #######  ##     ## ########   ######
*/
	/*
		Show/Hide Paswords
	 */
	$('.jsTogglePwd').on('click', function () {
		if ( $(this).prev('.jsToggleablePwd').attr('type') == 'password' )
		{
			$(this).text('Hide').prev('.jsToggleablePwd').attr('type', 'text');
		}
		else
		{
			$(this).text('Show').prev('.jsToggleablePwd').attr('type', 'password');
		}
	});

/*
 ######  ##       #### ########  ########  ######  ##     ##  #######  ##      ##  ######
##    ## ##        ##  ##     ## ##       ##    ## ##     ## ##     ## ##  ##  ## ##    ##
##       ##        ##  ##     ## ##       ##       ##     ## ##     ## ##  ##  ## ##
 ######  ##        ##  ##     ## ######    ######  ######### ##     ## ##  ##  ##  ######
      ## ##        ##  ##     ## ##             ## ##     ## ##     ## ##  ##  ##       ##
##    ## ##        ##  ##     ## ##       ##    ## ##     ## ##     ## ##  ##  ## ##    ##
 ######  ######## #### ########  ########  ######  ##     ##  #######   ###  ###   ######
*/
	// $('.slideshow').slick({
	// 	arrows: false,
	// 	autoplay: true,
	// 	autoplaySpeed: 2000,
	// 	speed: 750,
	// 	draggable: false,
	// 	fade: true,
	// 	pauseOnFocus: false,
	// 	pauseOnHover: false,
	// 	swipe: false,
	// 	cssEase: 'linear'
	// });

});

// import Glide from '@glidejs/glide'

// if ( $("body").hasClass("home") )
// {
// 	new Glide('.glide', {
// 		autoplay: 5000
// 	}).mount()
// }

/* header sticky on page scroll */
$(window).scroll(function () {
    if ($('body, html').scrollTop() > 70) {
        $('header').addClass('sticky');
    }

    if ($('body, html').scrollTop() < 50) {
        $('header.sticky').removeClass('sticky');
    }
});